// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Bundle from "./bundle.js"
import PhotoSheetProduct from "./photo-sheet-product.js"
import Product from "./product.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "product_id": {
      "column": {
        "default": null,
        "name": "product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "product_id",
      "selected_by_default": null,
      "translated": false
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "uuid"
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": false
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": false
    },
    "tenant_photo_products_count": {
      "column": {
        "default": 0,
        "name": "tenant_photo_products_count",
        "null": false,
        "type": "integer"
      },
      "name": "tenant_photo_products_count",
      "selected_by_default": null,
      "translated": false
    },
    "translated_resource_type": {
      "column": null,
      "name": "translated_resource_type",
      "selected_by_default": null,
      "translated": false
    },
    "purchase_price": {
      "column": null,
      "name": "purchase_price",
      "selected_by_default": null,
      "translated": false
    },
    "suggested_sales_price": {
      "column": null,
      "name": "suggested_sales_price",
      "selected_by_default": null,
      "translated": false
    },
    "resource": {
      "column": null,
      "name": "resource",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "PhotoProduct",
  "collectionKey": "photo_products",
  "collectionName": "photo_products",
  "i18nKey": "photo_product",
  "camelizedLower": "photoProduct",
  "name": "PhotoProduct",
  "nameDasherized": "photo-product",
  "pluralName": "photo_products",
  "ransackable_associations": [
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "resource_id",
      "name": "bundle",
      "macro": "belongs_to",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "PhotoProduct::Translation",
      "collectionName": null,
      "foreignKey": "photo_product_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "resource_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "photo_product_id",
      "name": "tenant_photo_products",
      "macro": "has_many",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "PhotoProduct::Translation",
      "collectionName": null,
      "foreignKey": "photo_product_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "product_id",
      "column": {
        "default": null,
        "name": "product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "purchase_price_cents",
      "column": {
        "default": null,
        "name": "purchase_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "purchase_price_currency",
      "column": {
        "default": "DKK",
        "name": "purchase_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "suggested_sales_price_cents",
      "column": {
        "default": null,
        "name": "suggested_sales_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "suggested_sales_price_currency",
      "column": {
        "default": "DKK",
        "name": "suggested_sales_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_photo_products_count",
      "column": {
        "default": 0,
        "name": "tenant_photo_products_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "resource_id",
      "name": "bundle",
      "macro": "belongs_to",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "resource_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    }
  ],
  "paramKey": "photo_product",
  "primaryKey": "id"
}

/** Frontend model for PhotoProduct. */
export default class PhotoProduct extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  productId() {
    return this.readAttributeUnderscore("product_id")
  }

  /** @returns {boolean} */
  hasProductId() {
    const value = this.productId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {number} */
  tenantPhotoProductsCount() {
    return this.readAttributeUnderscore("tenant_photo_products_count")
  }

  /** @returns {boolean} */
  hasTenantPhotoProductsCount() {
    const value = this.tenantPhotoProductsCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedResourceType() {
    return this.readAttributeUnderscore("translated_resource_type")
  }

  /** @returns {boolean} */
  hasTranslatedResourceType() {
    const value = this.translatedResourceType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  purchasePrice() {
    return this.readAttributeUnderscore("purchase_price")
  }

  /** @returns {boolean} */
  hasPurchasePrice() {
    const value = this.purchasePrice()

    return this._isPresent(value)
  }

  /** @returns {any} */
  suggestedSalesPrice() {
    return this.readAttributeUnderscore("suggested_sales_price")
  }

  /** @returns {boolean} */
  hasSuggestedSalesPrice() {
    const value = this.suggestedSalesPrice()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resource() {
    return this.readAttributeUnderscore("resource")
  }

  /** @returns {boolean} */
  hasResource() {
    const value = this.resource()

    return this._isPresent(value)
  }

  /** @returns {import("./bundle.js").default | null} */
  bundle() {
    return this._readBelongsToReflection({modelClass: Bundle, reflectionName: "bundle"})
  }

  /** @returns {Promise<import("./bundle.js").default | null>} */
  loadBundle() {
    if (!("resourceId" in this)) throw new Error("Foreign key method wasn't defined: resourceId")

    const id = this.resourceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bundle",
        model: this,
        modelClass: Bundle
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bundle.js").default | null>} */
  ensureBundleLoaded() {
    return this.ensureAssociationLoaded("bundle")
  }

  /** @returns {import("./photo-sheet-product.js").default | null} */
  photoSheetProduct() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProduct, reflectionName: "photo_sheet_product"})
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  loadPhotoSheetProduct() {
    if (!("resourceId" in this)) throw new Error("Foreign key method wasn't defined: resourceId")

    const id = this.resourceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product",
        model: this,
        modelClass: PhotoSheetProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  ensurePhotoSheetProductLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product")
  }

  /** @returns {import("./product.js").default | null} */
  product() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadProduct() {
    if (!("productId" in this)) throw new Error("Foreign key method wasn't defined: productId")

    const id = this.productId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureProductLoaded() {
    return this.ensureAssociationLoaded("product")
  }
}
